export enum QuestionFlags {
  ProceduresUnits = "procedures/units",
  ProceduresModifiers = "procedures/modifiers",
}
